// import React, { useState, Fragment, useEffect, useRef } from "react";

// import "./style.css";
// import data from "./mock-data.json";
// import ReadOnlyRow from "./ReadOnlyRow";
// import EditableRow from "./EditableRow";

// import Cookies from "js-cookie";

// import { Circles } from "react-loader-spinner";

// import { confirmAlert } from "react-confirm-alert";
// import "react-confirm-alert/src/react-confirm-alert.css";
// import { Divider } from "@tremor/react";

// import { useSelector } from "react-redux";
// import { fetchCompanies } from "../../../redux/companySlice";
// import { useDispatch } from "react-redux";


// //pdf creator
// import jsPDF from "jspdf";
// // import "jspdf-autotable";

// // import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';

// const Users = () => {
//   const [contacts, setContacts] = useState(data);
//   const [addFormData, setAddFormData] = useState({
//     username: "",
//     farmerid: "",
//     email: "",
//     fullname: "",
//     firstName: "",
//     lastName: "",
//     company: "",
//     category: "",
//     phone: "",
//   });

//   const [editFormData, setEditFormData] = useState({
//     id: "",
//     username: "",
//     email: "",
//     joined: "",
//     company: "",
//     category: "",
//     phone: "",
//     status: "",
//   });

//   const [editContactId, setEditContactId] = useState(null);

//   //display success info after successful registration
//   const [success, setSuccess] = useState("");

//   const [deleteState, setDeleteState] = useState("");

//   const [foundErr, setFoundErr] = useState(null);
//   const [foundErrAdd, setFoundErrAdd] = useState(null);
//   const [isLoading, setIsLoading] = useState(null);
//   const [isLoadingAdd, setIsLoadingAdd] = useState(null);
//   const [isLoadingSave, setIsLoadingSave] = useState(null);

//   //analysis Constants
//   const [totalUsers, settotalUsers] = useState(null);

//   const [totalActiveUsers, settotalActiveUsers] = useState(null);

//   //store select values in an array
//   const options = [
//     { value: "", text: "-- select Category --" },
//     { value: "Farmer", text: "Farmer" },
//     { value: "Clerk", text: "Clerk" },
//   ];
//   const [val, setVal] = useState("");

//   const [names, setNames] = useState({
//     fullname: "",
//     farmerid: "",
//     category: options[0].value,
//     username: "",
//     company: "",
//     phone: val,
//     gender: options[0].value,
//     status: "",
//   });

//   const dispatch = useDispatch();
//   //fetch companies using get
  
//   const companiesList = useSelector((state) => state.companies?.list || []);

// useEffect(() => {
//   dispatch(fetchCompanies());
// }, [dispatch]);



//   //number options
//   const numberOptions = [
//     { value: "", text: "10" },
//     { value: "10", text: "10" },
//     { value: "25", text: "20" },
//     { value: "50", text: "20" },

//     { value: "100", text: "20" },
//   ];

//   //search users in your company
//   const [searchUser, setSearchUser] = useState("");

//   //accept numbers only

//   //clear inputs
//   const firstnameref = useRef();
//   const lastnameref = useRef();
//   const fullnameRef = useRef();
//   const usernameRef = useRef();
//   const emailRef = useRef();
//   const passwordRef = useRef();
//   const phoneRef = useRef();
//   const companyRef = useRef();
//   const categoryRef = useRef();

//   //creating a fullname formatter here so that fullname data goes into the dataabase in the
//   //form of firstname Lastname
//   // Function to format the full name
//   const formatFullName = (firstName, lastName) => {
//     // Ensure the first letter of each name is capitalized
//     const formattedFirstName =
//       firstName.charAt(0).toUpperCase() + firstName.slice(1);
//     const formattedLastName =
//       lastName.charAt(0).toUpperCase() + lastName.slice(1);

//     // Combine the formatted names into the full name
//     const fullName = `${formattedFirstName} ${formattedLastName}`;

//     return fullName;
//   };

//   //format the company to start with capital letter and remove white spaces
//   // Function to format the company name
//   const formatCompanyName = (input) => {
//     // Remove leading and trailing white spaces
//     const trimmedInput = input.trim();

//     // Ensure the first letter is capitalized
//     const formattedCompanyName =
//       trimmedInput.charAt(0).toUpperCase() + trimmedInput.slice(1);

//     return formattedCompanyName;
//   };

//   //handle company input
//   const onCompanyChange = (event) => {
//     if (names.company.length >= 3) {
//       setFoundErrAdd("");
//     } else {
//       setFoundErrAdd("An error occurred");
//     }
//     const newCompanyName = event.target.value;
//     const formattedCompanyName = formatCompanyName(newCompanyName);

//     // Spreading "...state" ensures we don't "lose" fname,lname,email... etc
//     setNames((names) => ({
//       ...names,
//       company: formattedCompanyName,
//     }));
//   };

//   // handle on category change
//   const handleCategoryEdit = (event) => {
//     setSuccess(null);
//     setNames((names) => ({
//       ...names,
//       category: event.target.value,
//     }));

//     event.preventDefault();

//     const fieldName = event.target.getAttribute("name");
//     const category = event.target.value;

//     const newFormData = { ...editFormData };
//     newFormData["category"] = category;

//     setEditFormData(newFormData);
//   };

//   //handle on status change
//   const onStatusChange = (event) => {
//     setSuccess(null);
//     setNames((names) => ({
//       ...names,
//       status: event.target.value,
//     }));

//     event.preventDefault();

//     const fieldName = event.target.getAttribute("name");
//     const status = event.target.value;

//     const newFormData = { ...editFormData };
//     newFormData["status"] = status;

//     setEditFormData(newFormData);
//   };

//   //handle category input
//   const onCategoryChange = (event) => {
//     setSuccess(null);
//     setNames((names) => ({
//       ...names,
//       gender: event.target.value,
//     }));

//     event.preventDefault();

//     const fieldName = event.target.getAttribute("name");
//     const category = event.target.value;

//     const newFormData = { ...addFormData };
//     newFormData["category"] = category;

//     setAddFormData(newFormData);
//   };

//   const onPhoneChange = (event) => {
//     setNames((names) => ({
//       ...names,
//       phone: event.target.value,
//     }));

//     event.preventDefault();

//     const fieldName = event.target.getAttribute("name");
//     const category = event.target.value;

//     const newFormData = { ...addFormData };
//     newFormData["category"] = category;

//     setAddFormData(newFormData);
//   };

//   //data fetching
//   useEffect(() => {
//     //fetch users
//     const fetchAll = () => {
//       let adminCookie = Cookies.get("sessionidadmin");
//       if (adminCookie.length >= 1) {
//         setIsLoading(true);

//         setTimeout(() => {
//           fetch("https://api.terraweb.africa/getusers", {
//             method: "post",
//             headers: { "Content-Type": "application/JSON" },
//             body: JSON.stringify({
//               adminid: adminCookie,
//             }),
//           })
//             .then(function (response) {
//               if (response.status === 400) {
//                 throw Error("Wrong credentials");
//               }
//               if (response === 500) {
//                 throw Error("Could not complete request because of an error");
//               }

//               return response.json();
//             })
//             .then((user) => {
//               if (user[0].id >= 1) {
//                 //load data
//                 setFoundErrAdd(null);

//                 setIsLoading(null);
//                 setContacts(user);
//                 loadAnalysis(user);

//                 setSuccess(null);
//                 setDeleteState(null);

//                 //store a name after load to display in the title of the users table
//                 setNames((names) => ({
//                   ...names,
//                   company: user[0].company,
//                 }));
//               } else {
//                 //dont load

//                 setFoundErrAdd(null);
//                 setFoundErr(null);
//                 setIsLoading(null);
//                 setDeleteState(null);
//               }
//             })
//             .catch((err) => {
//               // setFoundErr(err.message);
//               setIsLoading(null);
//               // setFlag(1);
//             });
//         }, 1500);
//       } else {
//         setIsLoading(null);
//       }
//     };

//     //load profile
//     const fetchProfile = () => {
//       let adminCookie = "";
//       adminCookie = Cookies.get("sessionidadmin");
//       let userid = "";
//       userid = Cookies.get("sessioniduser");
//       if (adminCookie.length >= 1 || userid.length >= 1) {
//         setIsLoading(true);
//         setTimeout(() => {
//           fetch("https://api.terraweb.africa/loadProfile", {
//             method: "post",
//             headers: { "Content-Type": "application/JSON" },
//             body: JSON.stringify({
//               adminid: adminCookie,
//               userid: userid,
//             }),
//           })
//             .then(function (response) {
//               if (response.status === 400) {
//                 throw Error("Wrong credentials");
//               }
//               if (response === 500) {
//                 throw Error("Could not complete request because of an error");
//               }

//               return response.json();
//             })
//             .then((user) => {
//               if (user[0].username.length >= 1) {
//                 //load data

//                 setFoundErrAdd(null);

//                 setIsLoading(null);
//                 setContacts(user);

//                 setSuccess(null);
//                 setDeleteState(null);

//                 //store a name after load to display in the title of the users table
//                 setNames((names) => ({
//                   ...names,
//                   company: user[0].company,
//                 }));

//                 setAddFormData((prevState) => ({
//                   ...prevState,
//                   company: user[0].company,
//                 }));
//                 companyRef.current.value = user[0].company;
//               } else {
//                 //dont load

//                 setFoundErrAdd(null);
//                 setFoundErr(null);
//                 setIsLoading(null);
//                 setDeleteState(null);
//               }
//             })
//             .catch((err) => {
//               // setFoundErr(err.message);
//               setIsLoading(null);
//               // setFlag(1);
//             });
//         }, 150);
//       } else {
//         setIsLoading(null);
//       }
//     };

//     fetchAll();
//     fetchProfile();
//   }, []);

//   //success and errors clean out effect
//   // timer for success and error message
// // Success/Error auto-hide after 8 seconds
// useEffect(() => {
//   if (success || foundErrAdd) {
//     const timer = setTimeout(() => {
//       setSuccess("");
//       setFoundErrAdd("");
//     }, 8000);

//     return () => clearTimeout(timer); // cleanup
//   }
// }, [success, foundErrAdd]);

//   //load analysis
//   const loadAnalysis = (datamap) => {
//     settotalUsers(datamap.length);
//     let count = 0;

//     var i;
//     for (i = 0; i < datamap.length; i++) {
//       count = datamap[i].length;
//     }
//     settotalActiveUsers(count);
//   };

//   //search users
//   const searchUsers = () => {
//     // setContacts(null);
//     //fetch cookie
//     let adminCookie = Cookies.get("sessionidadmin");
//     if (adminCookie.length >= 1) {
//       setIsLoading(true);

//       setTimeout(() => {
//         fetch("https://api.terraweb.africa/searchUsers", {
//           method: "post",
//           headers: { "Content-Type": "application/JSON" },
//           body: JSON.stringify({
//             adminid: adminCookie,
//             username: searchUser,
//             email: searchUser,
//             phone: searchUser,
//             company: searchUser,
//             userid: searchUser,
//           }),
//         })
//           .then(function (response) {
//             if (response.status === 400) {
//               throw Error("Wrong credentials");
//             }
//             if (response === 500) {
//               throw Error("Could not complete request because of an error");
//             }

//             return response.json();
//           })
//           .then((user) => {
//             if (user[0].id >= 1) {
//               setFoundErr(null);
//               setFoundErrAdd(null);
//               setDeleteState(null);

//               setIsLoading(null);
//               setContacts(user);
//               loadAnalysis(user);

//               //load data
//             } else {
//               //dont load

//               setFoundErr(null);
//               setFoundErrAdd(null);
//               setIsLoading(null);
//               setDeleteState(null);
//             }
//           })
//           .catch((err) => {
//             // setFoundErr(err.message);
//             setIsLoading(null);
//             // setFlag(1);
//           });
//       }, 1500);
//     } else {
//       setIsLoading(null);
//     }
//   };

//   //fetch users
//   const fetchUsers = () => {
//     //fetch cookie
//     let adminCookie = Cookies.get("sessionidadmin");
//     if (adminCookie.length >= 1) {
//       setIsLoading(true);

//       setTimeout(() => {
//         fetch("https://api.terraweb.africa/getusers", {
//           method: "post",
//           headers: { "Content-Type": "application/JSON" },
//           body: JSON.stringify({
//             adminid: adminCookie,
//           }),
//         })
//           .then(function (response) {
//             if (response.status === 400) {
//               throw Error("Wrong credentials");
//             }
//             if (response === 500) {
//               throw Error("Could not complete request because of an error");
//             }

//             return response.json();
//           })
//           .then((user) => {
//             if (user[0].id >= 1) {
//               setFoundErr(null);
//               setFoundErrAdd(null);
//               setDeleteState(null);

//               setIsLoading(null);
//               setContacts(user);
//               loadAnalysis(user);

//               //load data
//             } else {
//               //dont load

//               setFoundErr(null);
//               setFoundErrAdd(null);
//               setIsLoading(null);
//               setDeleteState(null);
//             }
//           })
//           .catch((err) => {
//             // setFoundErr(err.message);
//             setIsLoading(null);
//             // setFlag(1);
//           });
//       }, 1500);
//     } else {
//       setIsLoading(null);
//     }
//   };

//   //temp handle add form change
//   const handleAddFormChange = (event) => {
//     event.preventDefault();

//     setSuccess(null);
//     setFoundErrAdd(null);

//     const fieldName = event.target.getAttribute("name");
//     let fieldValue = event.target.value;

//     // Check if the field name is "company" and apply formatting if needed
//     if (fieldName === "company") {
//       // Ensure the first letter is capitalized
//       fieldValue = fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1);

//       // Remove trailing white spaces
//       fieldValue = fieldValue.trim();
//       setAddFormData((prevState) => ({
//         ...prevState,
//         company: fieldValue,
//       }));
//     } else if (fieldName === "firstName") {
//       // Handle input changes for first name
//       if (/^[A-Za-z]+$/.test(fieldValue) || fieldValue === "") {
//         const fullName = formatFullName(fieldValue, addFormData.firstName);

//         setAddFormData((prevState) => ({
//           ...prevState,
//           firstName: fieldValue,
//           fullname: fullName,
//         }));
//       }
//     } else if (fieldName === "lastName") {
//       // Handle input changes for last name
//       if (/^[A-Za-z]+$/.test(fieldValue) || fieldValue === "") {
//         const fullName = formatFullName(addFormData.firstName, fieldValue);
//         setAddFormData((prevState) => ({
//           ...prevState,
//           lastName: fieldValue,
//           fullname: fullName,
//         }));
//       }
//     } else {
//       const newFormData = { ...addFormData };
//       newFormData[fieldName] = fieldValue;

//       setAddFormData(newFormData);
//     }
//   };

//   const handleEditFormChange = (event) => {
//     event.preventDefault();

//     const fieldName = event.target.getAttribute("name");

//     const fieldValue = event.target.value;

//     const newFormData = { ...editFormData };
//     newFormData[fieldName] = fieldValue;

//     setEditFormData(newFormData);
//   };

//   //refresh after add records
//   const refreshUsers = () => {
//     fetchUsers();
//   };

//   //add user to the database
//   const handleAddFormSubmit = (event) => {
//     event.preventDefault();
//     setSuccess(null);
//     setFoundErrAdd(null);

//     const newContact = {
//       username: addFormData.username,
//       farmerid: addFormData.farmerid,
//       email: addFormData.email,
//       password: addFormData.password,
//       fullname: addFormData.fullname,
//       company: addFormData.company,
//       category: addFormData.category,
//       phone: addFormData.phone,
//     };

//     if (
//       newContact.username.length >= 1 &&
//       newContact.email.length >= 1 &&
//       newContact.password.length >= 8 &&
//       newContact.company.length >= 1 &&
//       newContact.category.length >= 1 &&
//       newContact.phone.length === 10 &&
//       newContact.fullname.length >= 1
//     ) {
//       //send add agent request

//       let adminCookie = Cookies.get("sessionidadmin");
//       if (adminCookie.length >= 1) {
//         setIsLoadingAdd(true);
//         setTimeout(() => {
//           fetch("https://api.terraweb.africa/addUser", {
//             method: "post",
//             headers: { "Content-Type": "application/JSON" },
//             body: JSON.stringify({
//               adminid: adminCookie,
//               farmerid: newContact.farmerid,
//               username: newContact.username,
//               email: newContact.email,
//               password: newContact.password,
//               fullname: newContact.fullname,
//               company: newContact.company,
//               category: newContact.category,
//               phone: newContact.phone,
//             }),
//           })
//             .then(function (response) {
//               if (response.status === 400) {
//                 throw Error(
//                   "A user with the same farmerid or details seems to already exist, or there seems to be an error."
//                 );
//               }
//               if (response.status === 417) {
//                 throw Error("Fill all details");
//               }
//               if (response === 500) {
//                 throw Error("Could not complete request because of an error");
//               }

//               return response.json();
//             })
//             .then((user) => {
//               if (user) {
//                 setSuccess("success");
//                 setFoundErrAdd(null);

//                 setFoundErr(null);

//                 setIsLoadingAdd(null);
//                 // setContacts(user);

//                 //refresh data
//                 refreshUsers();

//                 //clear textboxes
//                 usernameRef.current.value = "";
//                 emailRef.current.value = "";
//                 passwordRef.current.value = "";
//                 phoneRef.current.value = "";
//                 // //clear the add form array
//                 // addFormData.username = "";
//                 // addFormData.email = "";
//                 // addFormData.phone = "";
//                 // addFormData.fullname = "";
//                 // // addFormData.company = "";
//                 // // addFormData.category = "";
//                 // addFormData.password = "";
//                 //load data
//               } else {
//                 setSuccess("not good");

//                 //dont load

//                 setFoundErrAdd(null);
//                 setIsLoadingAdd(null);
//                 addFormData.username = "";
//               }
//             })
//             .catch((err) => {
//               setSuccess("got error");

//               setFoundErrAdd(err.message);
//               setIsLoadingAdd(null);
//               newContact.username = "";

//               // setFlag(1);
//             });
//         }, 1000);
//       } else {
//         setIsLoadingAdd(null);
//       }
//     } else {
//     }
//   };

//   // //update users present in the database
//   // const handleEditFormSubmit = (event) => {
//   //   event.preventDefault();
//   //   const editedContact = {
//   //     id: editFormData.id,
//   //     farmerid: editFormData.farmerid,
//   //     username: editFormData.username,
//   //     email: editFormData.email,
//   //     password: editFormData.password,
//   //     phone: editFormData.phone,

//   //     category: editFormData.category,
//   //     company: editFormData.company,
//   //     status: editFormData.status,
//   //   };

//   //   const newContacts = [...contacts];

//   //   const index = contacts.findIndex((contact) => contact.id === editContactId);

//   //   newContacts[index] = editedContact;

//   //   // setContacts(newContacts);
//   //   // setEditContactId(null);

//   //   //update

//   //   let adminCookie = Cookies.get("sessionidadmin");

//   //   if (adminCookie.length >= 4) {
//   //     setIsLoadingSave(true);
//   //     setTimeout(() => {
//   //       fetch("https://api.terraweb.africa/updateUser", {
//   //         method: "post",
//   //         headers: { "Content-Type": "application/JSON" },
//   //         body: JSON.stringify({
//   //           adminid: adminCookie,
//   //           farmerid: newContacts[index].farmerid,
//   //           username: newContacts[index].username,
//   //           email: newContacts[index].email,
//   //           password: newContacts[index].password,
//   //           phone: newContacts[index].phone,
//   //           category: newContacts[index].category,
//   //           company: newContacts[index].company,
//   //           status: newContacts[index].status,
//   //         }),
//   //       })
//   //         .then(function (response) {
//   //           if (response.status === 400) {
//   //             throw Error(
//   //               "An error occurred, during update. An update requires a user category (farmer or clerk). Consider checking if you have the required previledges to perform that kind of an action."
//   //             );
//   //           }
//   //           if (response === 500) {
//   //             throw Error(
//   //               "Could not complete request because of a server error"
//   //             );
//   //           }

//   //           return response.json();
//   //         })
//   //         .then((user) => {
//   //           if (user >= 1) {
//   //             setFoundErr(null);
//   //             setSuccess("success");
//   //             setIsLoadingSave(null);
//   //             setDeleteState(null);

//   //             refreshUsers();
//   //             setEditContactId(null);
//   //             //load data
//   //           } else {
//   //             //dont load
//   //             setSuccess(null);
//   //             setFoundErrAdd(null);
//   //             setIsLoadingSave(null);
//   //             setDeleteState(null);
//   //             // addFormData.username = "";
//   //           }
//   //         })
//   //         .catch((err) => {
//   //           setFoundErrAdd(err.message);
//   //           setIsLoadingSave(null);
//   //           setSuccess(null);
//   //           // setFlag(1);
//   //         });
//   //     }, 1000);
//   //   } else {
//   //     setIsLoadingSave(null);
//   //   }
//   // };

//   // new AI2 edit submit
//   // Update users present in the database
// const handleEditFormSubmit = (event) => {
//   event.preventDefault();

//   const editedContact = {
//     id: editFormData.id,
//     farmerid: editFormData.farmerid,
//     username: editFormData.username,
//     email: editFormData.email,
//     password: editFormData.password,
//     phone: editFormData.phone,
//     category: editFormData.category,
//     company: editFormData.company,
//     status: editFormData.status,
//   };

//   const newContacts = [...contacts];
//   const index = contacts.findIndex((contact) => contact.id === editContactId);
//   newContacts[index] = editedContact;

//   const adminCookie = Cookies.get("sessionidadmin");

//   if (adminCookie && adminCookie.length >= 4) {
//     setIsLoadingSave(true);

//     fetch("https://api.terraweb.africa/updateUser", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         adminid: adminCookie,
//         ...newContacts[index], // spread avoids repetition
//       }),
//     })
//       .then((response) => {
//         if (response.status === 400) {
//           throw new Error(
//             "An update requires a valid user category (farmer or clerk). Please check your privileges."
//           );
//         }
//         if (response.status === 500) {
//           throw new Error("Could not complete request due to a server error.");
//         }
//         return response.json();
//       })
//       .then((result) => {
//         // Success case
//         setSuccess("User updated successfully ✅");
        
//         setFoundErrAdd(null);
//         setIsLoadingSave(false);
//         refreshUsers();
//         setEditContactId(null); // close edit row
//       })
//       .catch((err) => {
//         // Error case
//         setFoundErrAdd(err.message);
        
//         setSuccess(null);
//         setIsLoadingSave(false);
//       });
//   } else {
//     setIsLoadingSave(false);
//     setFoundErrAdd("Session expired or invalid admin ID.");
//   }
// };


//   //supply data to the editable row and the index the row should be displayed
//   const handleEditClick = (event, contact) => {
//     setNames((names) => ({
//       ...names,
//       category: "",
//       status: "",
//     }));
//     event.preventDefault();
//     setEditContactId(contact.id);

//     const formValues = {
//       id: contact.id,
//       farmerid: contact.farmerid,
//       username: contact.username,
//       email: contact.email,
//       password: contact.password,
//       created: contact.created,
//       category: contact.category,
//       company: contact.company,
//       phone: contact.phone,
//       status: contact.status,
//     };

//     setEditFormData(formValues);
//   };

//   const handleCancelClick = () => {
//     setEditContactId(null);
//     setNames((names) => ({
//       ...names,
//       category: "",
//       status: "",
//     }));
//   };

//   //confirm delete user
//   const onDeleteYes = (contactemail, category) => {
//     let adminCookie = Cookies.get("sessionidadmin");
//     let sType = Cookies.get("sessiontype");
//     if (adminCookie.length >= 4) {
//       fetch("https://api.terraweb.africa/deleteUser", {
//         method: "post",
//         headers: { "Content-Type": "application/JSON" },
//         body: JSON.stringify({
//           adminid: adminCookie,

//           email: contactemail,
//           category: category,
//           sType: sType,
//         }),
//       })
//         .then(function (response) {
//           if (response.status === 400) {
//             throw Error("An error occurred, during delete.");
//           }
//           if (response === 500) {
//             throw Error("Could not complete request because of an error");
//           }
//           if (response === 403) {
//             throw Error(
//               "You are forbidden from deleting users. Please contact your admin."
//             );
//           }

//           return response.json();
//         })
//         .then((user) => {
//           //
//           setDeleteState(user);

//           if (user) {
//             // refreshUsers();
//           } else {
//             //dont load
//           }
//         })
//         .catch((err) => {
//           setFoundErrAdd(err.message);
//         });
//     } else {
//     }
//   };

//    const handleDeleteClick = (contactemail, category) => {
//     //delete alert
//     confirmAlert({
//       customUI: ({ onClose }) => {
//         return (
//          <div className="deletediv bg-white br3 bb b--black-10  gold pa2 w-100 shadow-5 center ">
//             <h1>Confirm Delete Record</h1>
//             <p className="f3 black">Sure you want to delete this user record with ID: {contactemail}?</p>
//             <p className="b red f4">
//               Note that this cannot be <b className="red f3">UNDONE</b>
//             </p>
//             <label
//               className="dib w3 tc pa2 f3 ma2 white br-pill bg-red hover-bg-white hover-black "
//               onClick={onClose}
//             >
//               No
//             </label>
//             <label
//               className="dib w6 f5 fr tc pa3 white br-pill bg-blue hover-bg-red hover-white"
//               onClick={() => {
//                 onDeleteYes(contactemail);
//                 onClose();
//               }}
//             >
//               Yes, Delete it!
//             </label>
//           </div>
//         );
//       },
//     });
//   };



// //handle download table

// const handleDownloadTable = () => {
//   const doc = new jsPDF();

//   const currentDate = new Date().toLocaleString();

//   // Header
//   doc.setFontSize(16);
//   doc.text('Terraweb.africa', 14, 15);
//   doc.setFontSize(11);
//   doc.text('Empowering farmers through technology', 14, 22);
//   doc.setFontSize(10);
//   doc.text(`Generated on: ${currentDate}`, 14, 28);

 
//   // Table data
//   const tableColumn = [
//     'ID',
//     'Username',
//     'Email',
    
//     'Phone',
//     'Joined',
//     'Company',
//     'Last active',
//     'Category',
//     'Status',
//   ];
   
//   const tableRows = contacts?.map((contact) => [
//     contact.id,
//     contact.username,
//     contact.email,
//     contact.phone,
//     contact.joined,
//     contact.company,
//     contact.lastactive,
//     contact.category,
//     contact.status,
//   ]) || [];

//   autoTable(doc, {
//     head: [tableColumn],
//     body: tableRows,
//     startY: 35,
//     styles: { fontSize: 9 , color:"black"},
//     headStyles: { fillColor: [252, 156, 28] },
//     margin: { top: 35, bottom: 20 },
//     didDrawPage: function (data) {
//       // Footer
//       const pageCount = doc.internal.getNumberOfPages();
//       doc.setFontSize(9);
//       doc.text(
//         `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
//         data.settings.margin.left,
//         doc.internal.pageSize.height - 10
//       );

//       // Footer text
//       doc.text(
//         '© Terraweb.africa — All rights reserved.',
//         data.settings.margin.left + 70,
//         doc.internal.pageSize.height - 10
//       );
//     },
//   });

//   // Save PDF
//   doc.save('farmer_records.pdf');
// };
  
// //pagination next
// const handlePageNext = ()=>{

// }

// const handlePagePrevious = ()=>{

// }

//   //handle search user
//   const onSearchChange = (event) => {
//     event.preventDefault();
//     setSearchUser(event.target.value);
//   };
//   return (
  

//  <div className="app-container center br4 mt6 shadow-3">
//       {isLoading ? (
//         <div className="db mb2">
//           <Circles type="Oval" color="#000080" height={40} width={80} />
//         </div>
//       ) : null}

    

//            <div className="controlContainer center d-grid bg-white  br4 shadow-3 w-100">
//           <div>
//           <label className="ma2 black f3 b">
//           Total Users
//           <label className="strong red pa3">{totalUsers}</label></label>

//         <label className="pa3 green f3 b">
//           Total Active Users
//           <label className="strong green pa3">{totalUsers}</label>
//         </label>
//         </div>
//           <div className="grid-item  ">
//             <input
//               type="text"
//               className="searchInput "
//               placeholder="Search users"
//               onChange={onSearchChange}
//             />

        
//              <label className="pa1 hover-bg-transparent"onClick={searchUsers}>
//             <i className="fas fa-search f2 hover-gold orange"></i>
//             <span className=""></span>
//           </label>
//           </div>
//           <div className="grid-item ">
//             <label className="f3  ">
//               Showing <b>1-50</b> of <b> {contacts.length} </b>Entries
//             </label>
//             {/* <button
//               className=" br-pill bw0 ml2 bg-white orange f4  b pa2 hover-bg-orange hover-white"
//               type="submit"
//               onClick={handleAddFormSubmit}
//             >
//               back
//             </button> */}
//             {/* <button
//               // className=" br-pill bw0 ml2 bg-white orange f4  b pa2 hover-bg-orange hover-white"
//               className=" fas fa-caret-left f2 hover-gold"
//               type="submit"
//               onClick={handleAddFormSubmit}
//             >
//               next
//             </button> */}
//             <label className="pa3 hover-bg-transparent" onClick={handlePagePrevious}>
//             <i className="fas fa-caret-left f2 hover-gold"></i>
//             <span className=""></span>
//           </label>
//             <label className="pa3 hover-bg-transparent" onClick={handlePageNext}>
//             <i className="fas fa-caret-right f2 hover-gold"></i>
//             <span className=""></span>
//           </label>
//             <label className="pa3 hover-bg-transparent" onClick={handleDownloadTable}>
//             <i className="fas fa-download f2 hover-gold"></i>
//             <span className=""></span>
//           </label>
//           </div>
//         </div>
//       <div className="bg-white pa2 br4 shadow-2">
//         <form onSubmit={handleEditFormSubmit}>
//           <table>
//             <thead>
//               <tr>
//                 <th className="bg-gold">ID</th>
//                 <th className="bg-gold" >Farmer ID</th>
//                 <th className="bg-gold">Username</th>
//                 <th className="bg-gold">Email</th>
//                 <th className="bg-gold">Password</th>
//                 <th className="bg-gold">Phone</th>

//                 <th className="bg-gold">Created</th>
//                 <th className="bg-gold">Company</th>

//                 <th className="bg-gold">Last Active</th>
//                 <th className="bg-gold">Priviledges</th>
//                 <th className="bg-gold">Status</th>
//                 <th className="bg-gold">Edit Users</th>
//               </tr>
//             </thead>
//             <tbody>
//               {contacts.map((contact) => (
//                 <Fragment key={contact.id}>
//                   {editContactId === contact.id ? (
//                     <EditableRow
//                       handleEditFormSubmit={handleEditFormSubmit}
//                       isLoadingSave={isLoadingSave}
//                       editFormData={editFormData}
//                       handleEditFormChange={handleEditFormChange}
//                       handleCancelClick={handleCancelClick}
//                       onStatusChange={onStatusChange}
//                       names={names}
//                       handleCategoryEdit={handleCategoryEdit}
//                       handleDeleteClick={handleDeleteClick}
//                       optionsPreviledges={options}
//                       contact={contact}
//                     />
//                   ) : (
//                     <ReadOnlyRow
//                       contact={contact}
//                       handleEditClick={handleEditClick}
//                       handleDeleteClick={handleDeleteClick}
                 
//                     />
//                   )}
//                 </Fragment>
//               ))}
//             </tbody>
//           </table>
//         </form>
//       </div>
//       <div>
//         {foundErr ? <label className="dt red  pb2">{foundErr}</label> : null}
//   <div>
//  {/* {success==="success" ? (
//           <p className="card-tite w-50 f3 bg-white hover-blue br-pill pa1 green b">
//             Account details updated successfully.
//           </p>
//         ) :  null
//         // <p className="card-tite w-50 f3 bg-white hover-dark-red br-pill pa1 red b">
//         //     Error updating Account. Check your details and try again.
//         //   </p>
//           } */}
//           {success && <p className="green f2 b">{success}</p>}
// {foundErrAdd && <p className="red f2 b">{foundErrAdd}</p>}

//         </div>
       
//         <button
//           className="ml2 br-pill bg-white orange f3 pa3 b mt2 hover-bg-orange hover-white"
//           onClick={refreshUsers}
//         >
//           Refresh
//         </button>
//       </div>
//       <div className="form-container bg-white pa3 br4 shadow-3 w-90-l w-100">
//           <h2 className="f3 b gold">Add a User</h2>
//         <div className="grid-fields">
          
//           <div>
//             <h2>
//             <label className="b f4 ">Farmer ID (optional)</label>
//             </h2>
//             <input
//             // ref={firstnameref}
//             className=" tl"
//             placeholder="Farmer ID"
//             type="text"
//             name="farmerid"
//             onChange={handleAddFormChange}/>
//           </div>
//           <div>
//             <h2>
//             <label className="b f4 ">First Name</label>
//             </h2>
//             <input
//             ref={firstnameref}
//             className="tl  "
//             placeholder="First Name"
//             type="text"
//             name="firstName"
//             // value={addFormData.firstName}
//             onChange={handleAddFormChange}/>
          
//           </div>
//           <div>
//           <h2>
//             <label className="b f4 ">Last Name</label>
//           </h2>
//           <input
//             ref={lastnameref}
//             className="tl  "
//             placeholder="Last Name"
//             name="lastName"
//             type="text"
//             // value={addFormData.lastName}
//             onChange={handleAddFormChange}
//           />
//           </div>
//           <div>
//               <h2>
//               <label className="b f4 ">Username</label>
//               </h2>
//               <input
//               className=" tl  "
//               ref={usernameRef}
//               type="text"
//               name="username"
//               required="required"
//               placeholder="Enter a username..."
//               onChange={handleAddFormChange} />
//               </div>
//            <div>
//               <h2>
//                          <label className="b f4 ">Email</label>      </h2>
//                       <input className=" tl  "
//                       ref={emailRef}
//                           type="text"
//                         name="email"
//                           required="required"
//                           placeholder="Enter email..."
//                           onChange={handleAddFormChange}  />
//               </div>
//            <div>
//               <h2>
//                 <label className="b f4 ">Password</label> </h2>
//                 <input className="  tl  "
//                      ref={passwordRef}
//                      type="text"
//                      name="password"
//                      required="required"
//                      placeholder="Enter password..."  onChange={handleAddFormChange}  />
//              </div>
//             <div>
//               <h2>
//               <label className="b f4 ">Phone</label> </h2>
//               <input  className="  tl  "       ref={phoneRef}   type="text"
//                 // pattern="[0-9]*"
//               pattern="[0-9]*"
//                value={val}
//                onInput={(e) =>
//               setVal((v) => (e.target.validity.valid ? e.target.value : v))
//                }
//                placeholder="Enter Phone Number"
//                name="phone"onChange={handleAddFormChange} ></input>
//              </div>
//             <div>
//                <h2>
//                <b className="b f3 white">Choose the company</b></h2>
//                <select id="company" className="rounded f4 bg-white tracked br-pill w-25"  value={names.company}   
//                onChange={(e) => setNames((prev) => ({ ...prev, company: e.target.value }))} required>
//                <option value="">-- Choose a company --

              
//                </option>
//                 {(Array.isArray(companiesList) ? companiesList : []).map((company, idx) => (
//                 <option key={idx} value={company.name}>
//                   {company.name}
//                </option>
//                 ))}</select>
//              </div>
       
//             <div>
//                  <select ref={categoryRef} className=" rounded f4 bg-white tracked br-pill ml2 w-25 w-20-m"
//                  value={names.gender}
//                  onChange={onCategoryChange}>  {options.map((option) => (
//                    <option key={option.value} value={option.value}>
//                     {option.text}
//                     </option>
//                   ))} </select>
//               </div>

//         {isLoadingAdd ? (
//           <div className="dib ml2 mr2">
//             <Circles type="Oval" color="#000080" height={20} width={40} />
//           </div>
//         ) : null}

//        <div className="">
//         <label
//           className=" br-pill  bg-gold white f3  b pa2 hover-bg-orange hover-white"
//           // type="submit"
//           onClick={handleAddFormSubmit}
//         >
//           Add
//         </label>{foundErrAdd ? (
//           <label className=" f3 bg-white hover-dark-red br-pill pa3 red b dt">
//             {foundErrAdd}
//           </label>
//         ) : null}
// </div>
//         {deleteState ? (
//           <label className="card-tite w-70 f3 bg-white hover-dark-red br-pill pa1 mt2 red b dt">
//             {deleteState}
//           </label>
//         ) : null}
//         <div>
//  {success==="success"  ? (
//           <p className="card-tite w-50 f3 bg-white hover-blue br-pill pa1 green b">
//             Account details updated successfully.
//           </p>
//         ) :  null}

//         </div>
       
        
//     </div>
//         </div>
//         <div className="bg-white shadow-2  mt2 pa2 br4">
//         <label className="f3 b black ">Note:</label>
//         <label className="f3 b black">
//             You can only add or edit a user or Admin that belongs to your designated company. Fill the form inputs carefully!
//         </label>
//         </div>
    
//     </div>
    
//   );
// };

// export default Users;


// new with good layout add users
import React, { useState, useEffect, useRef } from "react";

import "./style.css";
import data from "./mock-data.json";

import Cookies from "js-cookie";

import { Circles } from "react-loader-spinner";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import { useSelector, useDispatch } from "react-redux";
import { fetchCompanies } from "../../../redux/companySlice";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import UsersDashboardAdmin from "./UsersDashboardAdmin";
import UsersFilterBar from "./UsersFilterBar";
import UsersFilteredView from "./UsersFilteredView";

const Users = () => {
  // ---------------------------------------------------------------------
  // Static options
  // ---------------------------------------------------------------------
  const categoryOptions = [
    { value: "", text: "-- select category --" },
    { value: "Farmer", text: "Farmer" },
    { value: "Clerk", text: "Clerk" },
  ];

  const genderOptions = [
    { value: "", text: "-- select gender --" },
    { value: "male", text: "Male" },
    { value: "female", text: "Female" },
  ];

  // ---------------------------------------------------------------------
  // Core data state
  // ---------------------------------------------------------------------
  const [contacts, setContacts] = useState(data);
  const [profile, setProfile] = useState(null);

  // FIX: the Add form is now fully controlled (no refs used to read/clear
  // values), and every field it actually submits lives here - including
  // password and category, which previously leaked in/out via a separate
  // "names" state that could go out of sync with what was submitted.
  const [addFormData, setAddFormData] = useState({
    firstName: "",
    lastName: "",
    fullname: "",
    username: "",
    email: "",
    password: "",
    phone: "",
    company: "",
    category: "",
    gender: "",
  });

  const [editFormData, setEditFormData] = useState({
    id: "",
    farmerid: "",
    username: "",
    email: "",
    phone: "",
    company: "",
    category: "",
    status: "",
    joined: "",
    lastactive: "",
  });

  const [editContactId, setEditContactId] = useState(null);

  // ---------------------------------------------------------------------
  // Status / feedback state
  // ---------------------------------------------------------------------
  const [success, setSuccess] = useState("");
  const [successAdd, setSuccessAdd] = useState("");
  const [foundErr, setFoundErr] = useState(null);
  const [foundErrAdd, setFoundErrAdd] = useState(null);

  const [isLoading, setIsLoading] = useState(null);
  const [isLoadingAdd, setIsLoadingAdd] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);

  const [deletingId, setDeletingId] = useState(null);

  // Bulk-action status objects: { state: "idle"|"loading"|"success"|"error", count }
  // Same pattern as Records.js so a bulk button always shows real progress
  // and never gets stuck on "Activating..." forever.
  const [activateStatus, setActivateStatus] = useState({ state: "idle", count: 0 });
  const [disableStatus, setDisableStatus] = useState({ state: "idle", count: 0 });
  const [deleteStatus, setDeleteStatus] = useState({ state: "idle", count: 0 });

  // ---------------------------------------------------------------------
  // Table controls
  // ---------------------------------------------------------------------
  const [searchUser, setSearchUser] = useState("");
  const [viewMode, setViewMode] = useState("all");
  // "all" | "active" | "pending" | "disabled" | "farmer" | "clerk"

  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 50;

  // Used to jump/focus the Add User form when the top "Add" shortcut is clicked
  const firstNameRef = useRef();

  // ---------------------------------------------------------------------
  // Companies (redux)
  // ---------------------------------------------------------------------
  const dispatch = useDispatch();
  const companiesList = useSelector((state) => state.companies?.list || []);

  useEffect(() => {
    dispatch(fetchCompanies());
  }, [dispatch]);

  // ---------------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------------
  const formatFullName = (firstName = "", lastName = "") => {
    const capitalize = (value) => {
      const trimmed = value.trim();
      if (!trimmed) return "";
      return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
    };

    return [capitalize(firstName), capitalize(lastName)]
      .filter(Boolean)
      .join(" ");
  };

  // Single source of truth for fullname - recomputed whenever firstName or
  // lastName changes (mirrors Records.js's pattern), instead of being
  // computed inconsistently inside separate change handlers.
  useEffect(() => {
    setAddFormData((prev) => {
      const nextFullname = formatFullName(prev.firstName, prev.lastName);
      if (nextFullname === prev.fullname) return prev;
      return { ...prev, fullname: nextFullname };
    });
  }, [addFormData.firstName, addFormData.lastName]);

  // ---------------------------------------------------------------------
  // Data fetching
  // ---------------------------------------------------------------------
  const fetchUsers = () => {
    const adminCookie = Cookies.get("sessionidadmin");
    if (!adminCookie || adminCookie.length < 1) {
      setIsLoading(null);
      return;
    }

    setIsLoading(true);

    fetch("https://api.terraweb.africa/getusers", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ adminid: adminCookie }),
    })
      .then((response) => {
        if (response.status === 400) throw Error("Wrong credentials");
        if (response.status === 500)
          throw Error("Could not complete request because of an error");
        return response.json();
      })
      .then((users) => {
        if (Array.isArray(users) && users[0]?.id) {
          setContacts(users);
          setFoundErr(null);
        }
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  // FIX: profile now lives in its own state instead of being written into
  // `contacts` - the old code called setContacts(user) here too, so a
  // race between this and fetchUsers() could briefly replace the whole
  // user table with a single profile row.
  const fetchProfile = () => {
    const adminCookie = Cookies.get("sessionidadmin");
    if (!adminCookie || adminCookie.length < 1) return;

    fetch("https://api.terraweb.africa/loadProfileAdmin", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ adminid: adminCookie }),
    })
      .then((response) => {
        if (response.status === 400) throw Error("Wrong credentials");
        if (response.status === 500)
          throw Error("Could not complete request because of an error");
        return response.json();
      })
      .then((res) => {
        if (res.success) {
          setProfile(res.data);
          setAddFormData((prev) => ({ ...prev, company: res.data.company }));
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchUsers();
    fetchProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Success/Error messages auto-hide after 8 seconds
  useEffect(() => {
    if (success || foundErrAdd || successAdd) {
      const timer = setTimeout(() => {
        setSuccess("");
        setFoundErrAdd("");
        setSuccessAdd("");
      }, 8000);
      return () => clearTimeout(timer);
    }
  }, [success, foundErrAdd, successAdd]);

  const refreshUsers = () => {
    fetchUsers();
  };

  const searchUsers = () => {
    const adminCookie = Cookies.get("sessionidadmin");
    if (!adminCookie || adminCookie.length < 1) {
      setIsLoading(null);
      return;
    }

    setIsLoading(true);

    fetch("https://api.terraweb.africa/searchUsers", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        adminid: adminCookie,
        username: searchUser,
        email: searchUser,
        phone: searchUser,
        company: searchUser,
        userid: searchUser,
      }),
    })
      .then((response) => {
        if (response.status === 400) throw Error("Wrong credentials");
        if (response.status === 500)
          throw Error("Could not complete request because of an error");
        return response.json();
      })
      .then((users) => {
        if (Array.isArray(users) && users[0]?.id) {
          setContacts(users);
          setFoundErr(null);
        }
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  const onSearchChange = (event) => {
    setSearchUser(event.target.value);
    setCurrentPage(1);
  };

  // ---------------------------------------------------------------------
  // Add User form
  // ---------------------------------------------------------------------
  const handleAddFormChange = (event) => {
    event.preventDefault();

    setSuccessAdd("");
    setFoundErrAdd(null);

    const fieldName = event.target.getAttribute("name");
    let fieldValue = event.target.value;

    if (fieldName === "firstName" || fieldName === "lastName") {
      // Allow letters, spaces, hyphens and apostrophes so compound or
      // hyphenated names ("Mary Jane", "Wanjiru-Mwangi", "O'Brien") aren't
      // silently rejected.
      const nameRegex = /^[A-Za-z\s'-]*$/;
      if (!nameRegex.test(fieldValue)) return;
    }

    if (fieldName === "phone") {
      // Digits only, allow a leading +
      const phoneRegex = /^[+]?[0-9]*$/;
      if (!phoneRegex.test(fieldValue)) return;
    }

    setAddFormData((prev) => ({ ...prev, [fieldName]: fieldValue }));
  };

  const resetAddForm = () => {
    setAddFormData((prev) => ({
      firstName: "",
      lastName: "",
      fullname: "",
      username: "",
      email: "",
      password: "",
      phone: "",
      // company stays locked to the admin's own society
      company: prev.company,
      category: "",
      gender: "",
    }));
  };

  // Generates a random password so the admin doesn't have to think one up -
  // mixes upper/lowercase, digits and a symbol, 12 chars long.
  const generateRandomPassword = () => {
    const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ";
    const lower = "abcdefghijkmnpqrstuvwxyz";
    const digits = "23456789";
    const symbols = "!@#$%&*?";
    const all = upper + lower + digits + symbols;

    const pick = (chars) => chars[Math.floor(Math.random() * chars.length)];

    // Guarantee at least one of each character class, then fill the rest
    // randomly, then shuffle so the required chars aren't always up front.
    const required = [pick(upper), pick(lower), pick(digits), pick(symbols)];
    const rest = Array.from({ length: 8 }, () => pick(all));

    const passwordChars = [...required, ...rest];
    for (let i = passwordChars.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [passwordChars[i], passwordChars[j]] = [passwordChars[j], passwordChars[i]];
    }

    const newPassword = passwordChars.join("");

    setSuccessAdd("");
    setFoundErrAdd(null);
    setAddFormData((prev) => ({ ...prev, password: newPassword }));
  };

  const handleAddFormSubmit = (event) => {
    event.preventDefault();

    setFoundErrAdd("");
    setSuccessAdd("");

    // FIX: block suspended admins from adding users, mirroring Records.js
    if (profile?.status === "suspended") {
      setFoundErrAdd("Your account is suspended. Contact support to add users.");
      return;
    }

    const newContact = {
      username: addFormData.username,
      email: addFormData.email,
      password: addFormData.password,
      fullname: addFormData.fullname,
      company: addFormData.company,
      category: addFormData.category,
      phone: addFormData.phone,
      gender: addFormData.gender,
    };

    // FIX: validation now checks real, sane thresholds instead of an
    // exact phone.length === 10 (which silently rejected valid numbers
    // with a country code) and gives one clear message instead of
    // failing with no feedback at all.
    const errors = [];
    if (newContact.username.trim().length < 3)
      errors.push("username (min 3 characters)");
    if (!/^\S+@\S+\.\S+$/.test(newContact.email))
      errors.push("a valid email");
    if (newContact.password.length < 8)
      errors.push("password (min 8 characters)");
    if (newContact.phone.replace(/\D/g, "").length < 9)
      errors.push("a valid phone number");
    if (!newContact.company) errors.push("company");
    if (!newContact.category) errors.push("category");
    if (!newContact.gender) errors.push("gender");
    if (newContact.fullname.trim().length < 3)
      errors.push("first and last name");

    if (errors.length > 0) {
      setFoundErrAdd(`Please provide: ${errors.join(", ")}.`);
      return;
    }

    const adminCookie = Cookies.get("sessionidadmin");
    if (!adminCookie || adminCookie.length < 1) {
      setFoundErrAdd("Session expired. Please login again.");
      return;
    }

    setIsLoadingAdd(true);

    fetch("https://api.terraweb.africa/addUser", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        adminid: adminCookie,
        username: newContact.username,
        email: newContact.email,
        password: newContact.password,
        fullname: newContact.fullname,
        company: newContact.company,
        category: newContact.category,
        phone: newContact.phone,
        gender: newContact.gender,
      }),
    })
      .then(async (response) => {
        const resData = await response.json().catch(() => ({}));

        if (response.status === 400) {
          throw new Error(
            resData.message ||
              "A user with the same details already exists, or the request was invalid."
          );
        }
        if (response.status === 417) {
          throw new Error(resData.message || "Fill all required details.");
        }
        if (!response.ok) {
          throw new Error(resData.message || "Could not complete request.");
        }

        return resData;
      })
      .then((resData) => {
        setSuccessAdd(resData.message || "User added successfully");
        setFoundErrAdd(null);
        setIsLoadingAdd(false);

        // FIX: reset the whole form (previously only three ref-backed
        // fields were cleared, so farmerid/category/password stuck around
        // silently after a successful add).
        resetAddForm();

        refreshUsers();
      })
      .catch((err) => {
        setIsLoadingAdd(false);
        setFoundErrAdd(err.message || "An unexpected error occurred");
      });
  };

  const scrollToAddForm = () => {
    firstNameRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    firstNameRef.current?.focus();
  };

  // ---------------------------------------------------------------------
  // Edit
  // ---------------------------------------------------------------------
  const handleEditFormChange = (event) => {
    event.preventDefault();
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    setEditFormData((prev) => ({ ...prev, [fieldName]: fieldValue }));
  };

  const handleEditClick = (event, contact) => {
    event.preventDefault();
    setEditContactId(contact.id);

    setEditFormData({
      id: contact.id,
      farmerid: contact.farmerid || "",
      username: contact.username || "",
      email: contact.email || "",
      phone: contact.phone || "",
      company: contact.company || "",
      category: contact.category || "",
      status: contact.status || "",
      joined: contact.joined || "",
      lastactive: contact.lastactive || "",
    });
  };

  const handleCancelClick = () => {
    setEditContactId(null);
  };

  const handleEditFormSubmit = (event) => {
    event.preventDefault();

    if (profile?.status === "suspended") {
      setFoundErrAdd("Your account is suspended. Contact support to edit users.");
      return;
    }

    const adminCookie = Cookies.get("sessionidadmin");
    if (!adminCookie || adminCookie.length < 4) {
      setFoundErrAdd("Session expired or invalid admin ID.");
      return;
    }

    setIsLoadingSave(true);

    fetch("https://api.terraweb.africa/updateUser", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        adminid: adminCookie,
        id: editFormData.id,
        farmerid: editFormData.farmerid,
        username: editFormData.username,
        email: editFormData.email,
        phone: editFormData.phone,
        company: editFormData.company,
        category: editFormData.category,
        status: editFormData.status,
      }),
    })
      .then(async (response) => {
        const resData = await response.json().catch(() => ({}));

        if (response.status === 400) {
          throw new Error(
            resData.message ||
              "An update requires a valid user category. Please check your privileges."
          );
        }
        if (!response.ok) {
          throw new Error(resData.message || "Could not complete request.");
        }
        return resData;
      })
      .then((resData) => {
        setSuccess(resData.message || "User updated successfully");
        setFoundErrAdd(null);
        setIsLoadingSave(false);
        setEditContactId(null);
        refreshUsers();
      })
      .catch((err) => {
        setFoundErrAdd(err.message);
        setSuccess(null);
        setIsLoadingSave(false);
      });
  };

  // ---------------------------------------------------------------------
  // Delete (single)
  // ---------------------------------------------------------------------
  const ACTION_TIMEOUT_MS = 15000;
  const ACTION_RESET_DELAY_MS = 3000;

  const onDeleteYes = (id) => {
    const adminCookie = Cookies.get("sessionidadmin");
    if (!adminCookie || adminCookie.length < 1) return;

    setDeletingId(id);

    let settled = false;
    const timeoutId = setTimeout(() => {
      if (settled) return;
      settled = true;
      setDeletingId(null);
      setFoundErrAdd("Delete request timed out. Please try again.");
    }, ACTION_TIMEOUT_MS);

    // FIX: previously sent the user's id under a field literally called
    // "email" (`email: contactemail`), which only worked if the backend
    // happened to key deletes off that field name by coincidence. Sending
    // an explicit `id` matches how every other endpoint on this page
    // (updateUser, addUser) identifies a record.
    fetch("https://api.terraweb.africa/deleteUser", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        adminid: adminCookie,
        id,
      }),
    })
      .then((response) => {
        if (response.status === 400) throw Error("An error occurred during delete.");
        if (response.status === 403)
          throw Error("You are forbidden from deleting users. Please contact your admin.");
        if (response.status === 500)
          throw Error("Could not complete request because of an error");
        return response.json();
      })
      .then((result) => {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);

        if (result) {
          refreshUsers();
        }
      })
      .catch((err) => {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        setFoundErrAdd(err.message || "Failed to delete user.");
      })
      .finally(() => {
        if (!settled) return;
        setDeletingId(null);
      });
  };

  const handleDeleteClick = (id) => {
    if (profile?.status === "suspended") {
      setFoundErrAdd("Your account is suspended. Contact support to delete users.");
      return;
    }

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="deletediv bg-white br3 bb b--black-10 gold pa2 w-100 shadow-5 center">
            <h1>Confirm Delete User</h1>
            <p className="f3 black">
              Sure you want to delete this user with ID: {id}?
            </p>
            <p className="b red f4">
              Note that this cannot be <b className="red f3">UNDONE</b>
            </p>
            <label
              className="dib w3 tc pa2 f3 ma2 white br-pill bg-red hover-bg-white hover-black"
              onClick={onClose}
            >
              No
            </label>
            <label
              className="dib w6 f5 fr tc pa3 white br-pill bg-blue hover-bg-red hover-white"
              onClick={() => {
                onDeleteYes(id);
                onClose();
              }}
            >
              Yes, Delete it!
            </label>
          </div>
        );
      },
    });
  };

  // ---------------------------------------------------------------------
  // Bulk actions (select, activate, disable, delete)
  // ---------------------------------------------------------------------
  const runBulkAction = async (setStatus, count, action) => {
    setStatus({ state: "loading", count });

    let settled = false;
    const timeoutId = setTimeout(() => {
      if (settled) return;
      settled = true;
      setStatus({ state: "error", count, message: "Request timed out" });
      setFoundErrAdd("Request timed out. Please check your connection and try again.");
      setTimeout(() => setStatus({ state: "idle", count: 0 }), ACTION_RESET_DELAY_MS);
    }, ACTION_TIMEOUT_MS);

    try {
      await action();

      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);

      setStatus({ state: "success", count });
      setTimeout(() => setStatus({ state: "idle", count: 0 }), ACTION_RESET_DELAY_MS);
    } catch (err) {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);

      setStatus({ state: "error", count, message: err?.message });
      setFoundErrAdd(err?.message || "Action failed. Please try again.");
      setTimeout(() => setStatus({ state: "idle", count: 0 }), ACTION_RESET_DELAY_MS);
    }
  };

  const renderActionLabel = (status, verbs) => {
    if (status.state === "loading") return `${verbs.loading} (${status.count})...`;
    if (status.state === "success") return `${verbs.success} (${status.count})`;
    if (status.state === "error") return verbs.error;
    return verbs.idle;
  };

  const handleSelectUser = (id) => {
    setSelectedUsers((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedUsers(currentUsers.map((u) => u.id));
    } else {
      setSelectedUsers([]);
    }
    setSelectAll(checked);
  };

  const updateUserStatus = async (adminCookie, record, status) => {
    const response = await fetch("https://api.terraweb.africa/updateUser", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        adminid: adminCookie,
        id: record.id,
        farmerid: record.farmerid,
        username: record.username,
        email: record.email,
        phone: record.phone,
        company: record.company,
        category: record.category,
        status,
      }),
    });

    if (!response.ok) {
      throw new Error("One or more users failed to update.");
    }
  };

  const handleActivateSelected = async () => {
    if (profile?.status === "suspended") {
      setFoundErrAdd("Your account is suspended. Contact support to activate users.");
      return;
    }

    const adminCookie = Cookies.get("sessionidadmin");
    if (!adminCookie) {
      setFoundErrAdd("Session expired.");
      return;
    }
    if (selectedUsers.length === 0) {
      setFoundErrAdd("Please select at least one user.");
      return;
    }

    const ids = [...selectedUsers];

    await runBulkAction(setActivateStatus, ids.length, async () => {
      await Promise.all(
        ids.map(async (id) => {
          const record = contacts.find((c) => c.id === id);
          if (!record) return;
          await updateUserStatus(adminCookie, record, "active");
        })
      );

      setSuccess(`${ids.length} user(s) activated`);
      setSelectedUsers([]);
      refreshUsers();
    });
  };

  const handleDisableSelected = async () => {
    if (profile?.status === "suspended") {
      setFoundErrAdd("Your account is suspended. Contact support to disable users.");
      return;
    }

    const adminCookie = Cookies.get("sessionidadmin");
    if (!adminCookie) {
      setFoundErrAdd("Session expired.");
      return;
    }
    if (selectedUsers.length === 0) {
      setFoundErrAdd("Please select at least one user.");
      return;
    }

    const ids = [...selectedUsers];

    await runBulkAction(setDisableStatus, ids.length, async () => {
      await Promise.all(
        ids.map(async (id) => {
          const record = contacts.find((c) => c.id === id);
          if (!record) return;
          await updateUserStatus(adminCookie, record, "disabled");
        })
      );

      setSuccess(`${ids.length} user(s) disabled`);
      setSelectedUsers([]);
      refreshUsers();
    });
  };

  const handleDeleteSelected = () => {
    if (profile?.status === "suspended") {
      setFoundErrAdd("Your account is suspended. Contact support to delete users.");
      return;
    }
    if (selectedUsers.length === 0) {
      setFoundErrAdd("Please select at least one user.");
      return;
    }

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="deletediv bg-white br3 shadow-5 pa4">
            <h2 className="red tc">Delete {selectedUsers.length} Users?</h2>
            <p className="black f4 tc">This action cannot be undone.</p>

            <div className="tc mt4">
              <button
                className="mr3 ph4 pv2 br-pill bn bg-light-gray pointer"
                onClick={onClose}
                disabled={deleteStatus.state === "loading"}
              >
                Cancel
              </button>

              <button
                className="ph4 pv2 br-pill bn bg-red white pointer"
                disabled={deleteStatus.state === "loading"}
                onClick={async () => {
                  await onBulkDeleteYes();
                  onClose();
                }}
              >
                {renderActionLabel(deleteStatus, {
                  loading: "Deleting",
                  success: "Deleted",
                  error: "Delete failed",
                  idle: "Delete Selected",
                })}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const onBulkDeleteYes = async () => {
    const adminCookie = Cookies.get("sessionidadmin");
    if (!adminCookie) {
      setFoundErrAdd("Admin session expired.");
      return;
    }

    const ids = [...selectedUsers];

    await runBulkAction(setDeleteStatus, ids.length, async () => {
      await Promise.all(
        ids.map(async (id) => {
          const response = await fetch("https://api.terraweb.africa/deleteUser", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ adminid: adminCookie, id }),
          });

          if (!response.ok) {
            throw new Error("One or more users failed to delete.");
          }
        })
      );

      setSuccess(`${ids.length} users deleted successfully`);
      setSelectedUsers([]);
      refreshUsers();
    });
  };

  // ---------------------------------------------------------------------
  // Filtering / sorting / pagination
  // ---------------------------------------------------------------------
  // const getFilteredUsers = () => {
  //   let filtered = contacts.filter((c) => {
  //     const q = searchUser.toLowerCase();

  //     const matchesSearch =
  //       !q ||
  //       c.username?.toLowerCase().includes(q) ||
  //       c.email?.toLowerCase().includes(q) ||
  //       c.farmerid?.toLowerCase().includes(q) ||
  //       c.phone?.toLowerCase().includes(q) ||
  //       c.company?.toLowerCase().includes(q);

  //     if (!matchesSearch) return false;

  //     const status = String(c.status || "").toLowerCase();
  //     const category = String(c.category || "").toLowerCase();

  //     if (viewMode === "active") return status === "active";
  //     if (viewMode === "pending") return status === "pending";
  //     if (viewMode === "disabled") return status === "disabled";
  //     if (viewMode === "farmer") return category === "farmer";
  //     if (viewMode === "clerk") return category === "clerk";

  //     return true;
  //   });

  //   if (sortColumn) {
  //     filtered = [...filtered].sort((a, b) => {
  //       let valueA = a[sortColumn];
  //       let valueB = b[sortColumn];

  //       if (!valueA) valueA = "";
  //       if (!valueB) valueB = "";

  //       if (sortColumn === "joined" || sortColumn === "lastactive") {
  //         valueA = new Date(valueA).getTime() || 0;
  //         valueB = new Date(valueB).getTime() || 0;
  //       } else if (sortColumn === "id") {
  //         valueA = Number(valueA);
  //         valueB = Number(valueB);
  //       } else {
  //         valueA = valueA.toString().toLowerCase();
  //         valueB = valueB.toString().toLowerCase();
  //       }

  //       if (valueA < valueB) return sortDirection === "asc" ? -1 : 1;
  //       if (valueA > valueB) return sortDirection === "asc" ? 1 : -1;
  //       return 0;
  //     });
  //   }

  //   return filtered;
  // };

//   const getFilteredUsers = () => {
//   let filtered = contacts.filter((c) => {
//     const q = searchUser.toLowerCase();

//     const matchesSearch =
//       !q ||
//       c.username?.toLowerCase().includes(q) ||
//       c.email?.toLowerCase().includes(q) ||
//       c.farmerid?.toLowerCase().includes(q) ||
//       c.phone?.toLowerCase().includes(q) ||
//       c.company?.toLowerCase().includes(q);

//     if (!matchesSearch) return false;

//     const status = String(c.status || "").toLowerCase();
//     const category = String(c.category || "").toLowerCase();

//     if (viewMode === "active") return status === "active";
//     if (viewMode === "pending") return status === "pending";
//     if (viewMode === "disabled") return status === "disabled";
//     if (viewMode === "farmer") return category === "farmer";
//     if (viewMode === "clerk") return category === "clerk";

//     return true;
//   });

//   if (sortColumn) {
//     // User clicked a caret: sort by that column
//     filtered = [...filtered].sort((a, b) => {
//       let valueA = a[sortColumn];
//       let valueB = b[sortColumn];

//       if (!valueA) valueA = "";
//       if (!valueB) valueB = "";

//       if (sortColumn === "joined" || sortColumn === "lastactive") {
//         valueA = new Date(valueA).getTime() || 0;
//         valueB = new Date(valueB).getTime() || 0;
//       } else if (sortColumn === "id") {
//         valueA = Number(valueA);
//         valueB = Number(valueB);
//       } else {
//         valueA = valueA.toString().toLowerCase();
//         valueB = valueB.toString().toLowerCase();
//       }

//       if (valueA < valueB) return sortDirection === "asc" ? -1 : 1;
//       if (valueA > valueB) return sortDirection === "asc" ? 1 : -1;
//       return 0;
//     });
//   } else {
//     // Default (no caret selected): newest first
//     filtered = [...filtered].sort((a, b) => {
//       const dateA = new Date(a.joined).getTime() || 0;
//       const dateB = new Date(b.joined).getTime() || 0;

//       if (dateB !== dateA) return dateB - dateA;

//       // Tiebreaker: higher id = newer
//       return Number(b.id) - Number(a.id);
//     });
//   }

//   return filtered;
// };

const getFilteredUsers = () => {
  const text = (v) => String(v ?? "").toLowerCase();

  let filtered = contacts.filter((c) => {
    const q = searchUser.trim().toLowerCase();
    const qDigits = q.replace(/\D/g, ""); // digits only, for phone matching

    const matchesPhone =
      qDigits.length > 0 &&
      String(c.phone ?? "").replace(/\D/g, "").includes(qDigits);

    const matchesSearch =
      !q ||
      text(c.username).includes(q) ||
      text(c.email).includes(q) ||
      text(c.farmerid).includes(q) ||
      text(c.company).includes(q) ||
      matchesPhone;

    if (!matchesSearch) return false;

    const status = text(c.status);
    const category = text(c.category);

    if (viewMode === "active") return status === "active";
    if (viewMode === "pending") return status === "pending";
    if (viewMode === "disabled") return status === "disabled";
    if (viewMode === "farmer") return category === "farmer";
    if (viewMode === "clerk") return category === "clerk";

    return true;
  });

  if (sortColumn) {
    // User clicked a caret: sort by that column
    filtered = [...filtered].sort((a, b) => {
      let valueA = a[sortColumn];
      let valueB = b[sortColumn];

      if (!valueA) valueA = "";
      if (!valueB) valueB = "";

      if (sortColumn === "joined" || sortColumn === "lastactive") {
        valueA = new Date(valueA).getTime() || 0;
        valueB = new Date(valueB).getTime() || 0;
      } else if (sortColumn === "id") {
        valueA = Number(valueA);
        valueB = Number(valueB);
      } else {
        valueA = valueA.toString().toLowerCase();
        valueB = valueB.toString().toLowerCase();
      }

      if (valueA < valueB) return sortDirection === "asc" ? -1 : 1;
      if (valueA > valueB) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  } else {
    // Default (no caret selected): newest first
    filtered = [...filtered].sort((a, b) => {
      const dateA = new Date(a.joined).getTime() || 0;
      const dateB = new Date(b.joined).getTime() || 0;

      if (dateB !== dateA) return dateB - dateA;

      // Tiebreaker: higher id = newer
      return Number(b.id) - Number(a.id);
    });
  }

  return filtered;
};



  const filteredUsers = getFilteredUsers();

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.max(1, Math.ceil(filteredUsers.length / usersPerPage));

  // const handleSort = (column) => {
  //   if (sortColumn === column) {
  //     setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
  //   } else {
  //     setSortColumn(column);
  //     setSortDirection("asc");
  //   }
  // };

const handleSort = (column) => {
  if (sortColumn !== column) {
    setSortColumn(column);
    setSortDirection("asc");
  } else if (sortDirection === "asc") {
    setSortDirection("desc");
  } else {
    setSortColumn("");
    setSortDirection("asc");
  }
};

  // FIX: these were empty no-op functions before - the pagination arrows
  // in the header rendered but did nothing.
  const handlePageNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const handlePagePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  // ---------------------------------------------------------------------
  // PDF export
  // ---------------------------------------------------------------------
  // const handleDownloadTable = () => {
  //   const doc = new jsPDF();
  //   const currentDate = new Date().toLocaleString();

  //   doc.setFontSize(16);
  //   doc.text("Terraweb.africa", 14, 15);
  //   doc.setFontSize(11);
  //   doc.text("Empowering farmers through technology", 14, 22);
  //   doc.setFontSize(10);
  //   doc.text(`Generated on: ${currentDate}`, 14, 28);

  //   const tableColumn = [
  //     "ID",
  //     "Username",
  //     "Email",
  //     "Phone",
  //     "Joined",
  //     "Company",
  //     "Last active",
  //     "Category",
  //     "Status",
  //   ];

  //   const tableRows =
  //     filteredUsers?.map((contact) => [
  //       contact.id,
  //       contact.username,
  //       contact.email,
  //       contact.phone,
  //       contact.joined,
  //       contact.company,
  //       contact.lastactive,
  //       contact.category,
  //       contact.status,
  //     ]) || [];

  //   autoTable(doc, {
  //     head: [tableColumn],
  //     body: tableRows,
  //     startY: 35,
  //     styles: { fontSize: 9, textColor: [0, 0, 0] },
  //     headStyles: { fillColor: [252, 156, 28] },
  //     margin: { top: 35, bottom: 20 },
  //     didDrawPage: function (tableData) {
  //       const pageCount = doc.internal.getNumberOfPages();
  //       doc.setFontSize(9);
  //       doc.text(
  //         `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
  //         tableData.settings.margin.left,
  //         doc.internal.pageSize.height - 10
  //       );
  //       doc.text(
  //         "© Terraweb.africa — All rights reserved.",
  //         tableData.settings.margin.left + 70,
  //         doc.internal.pageSize.height - 10
  //       );
  //     },
  //   });

  //   doc.save("terraweb_users.pdf");
  // };

  const handleDownloadTable = () => {
    const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;
  
    const BRAND = [252, 156, 28];
    const DARK = [33, 37, 41];
    const MUTED = [110, 117, 125];
  
    // Replace with however you store the logged-in user
    const printedBy = profile?.fullname || profile?.username || "Unknown user";
    const printedByRole = profile?.role || profile?.category || "";
    const printedByCompany = profile?.company || "Terraweb.africa";
  
    const generatedOn = new Date().toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  
    const dash = (v) => (v === null || v === undefined || v === "" ? "-" : String(v));
  
    // Vector user icon (circle badge with head and shoulders)
    const drawUserIcon = (cx, cy, r = 5) => {
      doc.setFillColor(...BRAND);
      doc.circle(cx, cy, r, "F");
      doc.setFillColor(255, 255, 255);
      doc.circle(cx, cy - r * 0.25, r * 0.35, "F"); // head
      doc.ellipse(cx, cy + r * 0.65, r * 0.6, r * 0.36, "F"); // shoulders
    };
  
    const HEADER_HEIGHT = 40;
  
    const drawHeader = () => {
      // Brand block
      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.setTextColor(...BRAND);
      doc.text("Terraweb.africa", marginX, 16);
  
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(...MUTED);
      doc.text("Empowering farmers through technology", marginX, 22);
  
      // Printed-by block (right aligned)
      const iconX = pageWidth - marginX - 62;
      drawUserIcon(iconX, 15, 5);
  
      const textX = iconX + 9;
      doc.setFontSize(7.5);
      doc.setTextColor(...MUTED);
      doc.text("PRINTED BY", textX, 11.5);
  
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor(...DARK);
      doc.text(printedBy, textX, 16);
  
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(...MUTED);
      const sub = [printedByRole, printedByCompany].filter(Boolean).join("  |  ");
      doc.text(sub, textX, 20.5);
  
      // Divider
      doc.setDrawColor(...BRAND);
      doc.setLineWidth(0.8);
      doc.line(marginX, 28, pageWidth - marginX, 28);
  
      // Report title + meta
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.setTextColor(...DARK);
      doc.text("User Records Report", marginX, 35);
  
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(...MUTED);
      doc.text(
        `Generated: ${generatedOn}   |   Total users: ${filteredUsers?.length || 0}`,
        pageWidth - marginX,
        35,
        { align: "right" }
      );
    };
  
    const tableColumn = [
      "ID",
      "Username",
      "Email",
      "Phone",
      "Joined",
      "Company",
      "Last active",
      "Category",
      "Status",
    ];
  
    const tableRows =
      filteredUsers?.map((c) => [
        dash(c.id),
        dash(c.username),
        dash(c.email),
        dash(c.phone),
        dash(c.joined),
        dash(c.company),
        dash(c.lastactive),
        dash(c.category),
        dash(c.status),
      ]) || [];
  
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: HEADER_HEIGHT,
      margin: { top: HEADER_HEIGHT, left: marginX, right: marginX, bottom: 18 },
      theme: "grid",
      styles: {
        font: "helvetica",
        fontSize: 8.5,
        textColor: DARK,
        cellPadding: { top: 2.8, bottom: 2.8, left: 3, right: 3 },
        lineColor: [225, 228, 232],
        lineWidth: 0.2,
        valign: "middle",
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: BRAND,
        textColor: 255,
        fontStyle: "bold",
        halign: "left",
      },
      alternateRowStyles: { fillColor: [250, 247, 242] },
      columnStyles: {
        0: { cellWidth: 14, halign: "center" },
        1: { cellWidth: 36, fontStyle: "bold" },
        2: { cellWidth: "auto" },
        3: { cellWidth: 30 },
        4: { cellWidth: 26 },
        5: { cellWidth: 34 },
        6: { cellWidth: 28 },
        7: { cellWidth: 22 },
        8: { cellWidth: 22, halign: "center" },
      },
      // Color-coded status text
      didParseCell: (data) => {
        if (data.section === "body" && data.column.index === 8) {
          const s = String(data.cell.raw).toLowerCase();
          data.cell.styles.fontStyle = "bold";
          if (s === "active") data.cell.styles.textColor = [25, 135, 84];
          else if (s === "pending") data.cell.styles.textColor = [200, 120, 0];
          else if (s === "disabled") data.cell.styles.textColor = [200, 50, 50];
        }
      },
      // Header repeats on every page
      didDrawPage: drawHeader,
    });
  
    // Footer with correct total page count (drawn after all pages exist)
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setDrawColor(225, 228, 232);
      doc.setLineWidth(0.3);
      doc.line(marginX, pageHeight - 14, pageWidth - marginX, pageHeight - 14);
  
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(...MUTED);
      doc.text("© Terraweb.africa. All rights reserved.", marginX, pageHeight - 9);
      doc.text("Confidential: for authorized use only", pageWidth / 2, pageHeight - 9, {
        align: "center",
      });
      doc.text(`Page ${i} of ${totalPages}`, pageWidth - marginX, pageHeight - 9, {
        align: "right",
      });
    }
  
    doc.save(`terraweb_users_${new Date().toISOString().slice(0, 10)}.pdf`);
  };
  
  
  // ---------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------
  return (
    <div className="records-app-container center mt6 vh-100">
      {isLoading ? (
        <div className="db mb2">
          <Circles type="Oval" color="#000080" height={40} width={80} />
        </div>
      ) : null}

      <div className="dib-l br4 shadow-3">
        {/* Profile card */}
        <div className="flex items-center bg-white pa3 mb3 w-100">
          <div className="mr3 bg-white">
            <img
              className="br-100"
              style={{ height: "10rem", width: "10rem", objectFit: "cover" }}
              alt="profile"
              src={
                profile?.gender === "female"
                  ? "/img/femaleavatar.jpg"
                  : "/img/maleavatar.jpeg"
              }
            />
          </div>

          <div className="lh-copy">
            <h1 className="f2 b gold ma0 ttu">{profile?.username || ""}</h1>

            {profile?.status && (
              <span
                className={`dib br-pill ph2 pv1 f6 fw7 mv1 ${
                  profile.status === "active"
                    ? "bg-light-green dark-green"
                    : "bg-light-red dark-red"
                }`}
              >
                {profile.status === "active" ? "● Active" : "⛔ Suspended"}
              </span>
            )}

            <div className="f2 black">{profile?.company || "No company assigned"}</div>
          </div>
        </div>

        <UsersDashboardAdmin users={contacts} loading={isLoading} />

        {/* Search + pagination row */}
        <div className="controlContainer bg-white w-100">
          <div className="grid-item">
            <input
              type="text"
              className="searchInput"
              placeholder="Search users"
              onChange={onSearchChange}
            />
            <label className="pa1 hover-bg-transparent" onClick={searchUsers}>
              <i className="fas fa-search f2 hover-gold orange"></i>
            </label>
          </div>

          <div className="grid-item flex items-center">
            <div className="flex items-center">
              <label className="f2 fw6 mv0">
                <b>{filteredUsers.length === 0 ? 0 : indexOfFirstUser + 1}</b>–
                <b>{Math.min(indexOfLastUser, filteredUsers.length)}</b> of{" "}
                <b>{filteredUsers.length}</b>
              </label>
            </div>

            <div className="grid-item flex items-center">
              <button
                className="bn bg-transparent pa2 pointer flex items-center justify-center"
                disabled={currentPage === 1}
                onClick={handlePagePrevious}
                aria-label="Previous page"
              >
                <i className="fas fa-caret-left f1 dark-gray hover-gold"></i>
              </button>

              <button
                className="bn bg-transparent pa2 pointer flex items-center justify-center ml3 mr3"
                disabled={currentPage === totalPages}
                onClick={handlePageNext}
                aria-label="Next page"
              >
                <i className="fas fa-caret-right f1 dark-gray hover-gold"></i>
              </button>

              <label className="pa2 pointer" onClick={handleDownloadTable}>
                <i className="fas fa-download f1 hover-gold"></i>
              </label>

              <label
                className="br-pill bg-orange white f5 b pa2 ph3 hover-bg-orange hover-white pointer dib ml2"
                onClick={scrollToAddForm}
              >
                Add
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white br3 shadow-2 pa3 mb3">
        <div className="flex flex-column flex-row-l justify-between items-start items-center-l">
          {/* Filters */}
          <div className="mb3 mb0-l">
            <UsersFilterBar viewMode={viewMode} setViewMode={setViewMode} />
          </div>

          {/* Bulk Actions */}
          <div className="flex flex-wrap">
            <button
              className="ma1 bn br-pill bg-dark-green white ph3 pv2 pointer fw6"
              onClick={handleActivateSelected}
              disabled={activateStatus.state === "loading"}
            >
              {renderActionLabel(activateStatus, {
                loading: "Activating",
                success: "✅ Activated",
                error: "⚠ Activate failed",
                idle: "✅ Activate Selected",
              })}
            </button>

            <button
              className="ma1 bn br-pill bg-gold black ph3 pv2 pointer fw6"
              onClick={handleDisableSelected}
              disabled={disableStatus.state === "loading"}
            >
              {renderActionLabel(disableStatus, {
                loading: "Disabling",
                success: "⛔ Disabled",
                error: "⚠ Disable failed",
                idle: "⛔ Disable Selected",
              })}
            </button>

            <button
              className="ma1 bn br-pill bg-red white ph3 pv2 pointer fw6"
              onClick={handleDeleteSelected}
              disabled={deleteStatus.state === "loading"}
            >
              {renderActionLabel(deleteStatus, {
                loading: "Deleting",
                success: "🗑 Deleted",
                error: "⚠ Delete failed",
                idle: "🗑 Delete Selected",
              })}
            </button>
          </div>
        </div>
      </div>

      <div className="records-table-wrapper">
        <div className="records-table-scroll">
          <UsersFilteredView
            users={currentUsers}
            editContactId={editContactId}
            editFormData={editFormData}
            handleEditClick={handleEditClick}
            handleDeleteClick={handleDeleteClick}
            handleEditFormChange={handleEditFormChange}
            handleEditFormSubmit={handleEditFormSubmit}
            handleCancelClick={handleCancelClick}
            isLoadingSave={isLoadingSave}
            deletingId={deletingId}
            selectedUsers={selectedUsers}
            handleSelectUser={handleSelectUser}
            selectAll={selectAll}
            handleSelectAll={handleSelectAll}
            sortColumn={sortColumn}
            sortDirection={sortDirection}
            handleSort={handleSort}
            companiesList={companiesList}
          />
        </div>
      </div>

      <div>
        {success && <p className="green f2 b">{success}</p>}
        {foundErrAdd && <p className="red f2 b">{foundErrAdd}</p>}

        <button
          className="ml2 br-pill bg-white orange f3 pa3 b mt2 hover-bg-orange hover-white"
          onClick={refreshUsers}
        >
          Refresh
        </button>
      </div>

      {/* Add User */}
      <div className="recordsdiv">
        <h2 className="f3 b gold">Add a User</h2>

        <div className="form-grid">
          {/* Company — locked to the admin's own society, same rule the
              Records page follows ("you can only add or edit for your
              designated company"). */}
          <div>
            <label className="b f5 db mb2">Company</label>
            <select
              value={addFormData.company}
              disabled
              title="You can only add users for your own company"
            >
              <option value={addFormData.company}>
                {addFormData.company || "No company assigned"}
              </option>
            </select>
          </div>

          {/* First Name */}
          <div>
            <label className="b f5 db mb2">First Name</label>
            <input
              type="text"
              name="firstName"
              ref={firstNameRef}
              value={addFormData.firstName}
              placeholder="First Name"
              onChange={handleAddFormChange}
            />
          </div>

          {/* Last Name */}
          <div>
            <label className="b f5 db mb2">Last Name</label>
            <input
              type="text"
              name="lastName"
              value={addFormData.lastName}
              placeholder="Last Name"
              onChange={handleAddFormChange}
            />
          </div>

          {/* Username */}
          <div>
            <label className="b f5 db mb2">Username</label>
            <input
              type="text"
              name="username"
              value={addFormData.username}
              placeholder="Enter a username..."
              onChange={handleAddFormChange}
              required
            />
          </div>

          {/* Email */}
          <div>
            <label className="b f5 db mb2">Email</label>
            <input
              type="email"
              name="email"
              value={addFormData.email}
              placeholder="Enter email..."
              onChange={handleAddFormChange}
              required
            />
          </div>

          {/* Password */}
          <div>
            <label className="b f5 db mb2">Password</label>
            <div className="flex items-center">
              <input
                type="text"
                name="password"
                value={addFormData.password}
                placeholder="Enter password... (min 8 characters)"
                onChange={handleAddFormChange}
                required
              />
              <button
                type="button"
                className="bn bg-transparent pointer ml2"
                onClick={generateRandomPassword}
                title="Generate random password"
              >
                <i className="fas fa-dice f3 gold hover-orange"></i>
              </button>
            </div>
          </div>

          {/* Phone */}
          <div>
            <label className="b f5 db mb2">Phone</label>
            <input
              type="tel"
              name="phone"
              value={addFormData.phone}
              placeholder="Enter phone number"
              onChange={handleAddFormChange}
            />
          </div>

          {/* Category */}
          <div>
            <label className="b f5 db mb2">Category</label>
            <select
              name="category"
              value={addFormData.category}
              onChange={handleAddFormChange}
            >
              {categoryOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
          </div>

          {/* Gender */}
          <div>
            <label className="b f5 db mb2">Gender</label>
            <select
              name="gender"
              value={addFormData.gender}
              onChange={handleAddFormChange}
            >
              {genderOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Button + loading */}
        <div className="mt3">
          {isLoadingAdd ? (
            <div className="dib pa3">
              <Circles type="Oval" color="#000080" height={30} width={40} />
            </div>
          ) : (
            <label
              className="br-pill bg-orange white f5 b pa2 hover-bg-orange hover-white pointer dib"
              onClick={handleAddFormSubmit}
            >
              Add
            </label>
          )}
        </div>

        {successAdd && (
          <div className="br-pill bg-light-green pa2 mt2">
            <label className="f5 green b">
              {typeof successAdd === "string" ? successAdd : successAdd.message}
            </label>
          </div>
        )}

        {foundErrAdd && <label className="f5 red b db mt2">{foundErrAdd}</label>}

        <div className="bg-white shadow-3 pa3 br4 mt3">
          <label className="f5 b black db mb1">Note:</label>
          <span className="f5 black">
            You can only add or edit a user that belongs to your designated
            company. Fill the form inputs carefully!
          </span>
        </div>
      </div>
    </div>
  );
};

export default Users;